'use strict';

var _regeneratorRuntime = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/regenerator");

var _objectSpread = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/objectSpread");

var _asyncToGenerator = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _asyncIterator = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/asyncIterator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var debug = require('debug');

var configure = require('../lib/configure.js');

var toUrlSearchParams = require('../lib/to-url-search-params.js');

var httpRpcWireFormat = require('../lib/http-rpc-wire-format.js');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var debug__default =
/*#__PURE__*/
_interopDefaultLegacy(debug);

var log = debug__default["default"]('ipfs-http-client:pubsub:subscribe');

var createSubscribe = function createSubscribe(options, subsTracker) {
  return configure.configure(function (api) {
    function subscribe(_x, _x2) {
      return _subscribe.apply(this, arguments);
    }

    function _subscribe() {
      _subscribe = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(topic, handler) {
        var options,
            done,
            fail,
            result,
            ffWorkaround,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
                options.signal = subsTracker.subscribe(topic, handler, options.signal);
                result = new Promise(function (resolve, reject) {
                  done = resolve;
                  fail = reject;
                });
                ffWorkaround = setTimeout(function () {
                  return done();
                }, 1000);
                api.post('pubsub/sub', {
                  signal: options.signal,
                  searchParams: toUrlSearchParams.toUrlSearchParams(_objectSpread({
                    arg: httpRpcWireFormat.textToUrlSafeRpc(topic)
                  }, options)),
                  headers: options.headers
                }).catch(function (err) {
                  subsTracker.unsubscribe(topic, handler);
                  fail(err);
                }).then(function (response) {
                  clearTimeout(ffWorkaround);

                  if (!response) {
                    return;
                  }

                  readMessages(response, {
                    onMessage: handler,
                    onEnd: function onEnd() {
                      return subsTracker.unsubscribe(topic, handler);
                    },
                    onError: options.onError
                  });
                  done();
                });
                return _context.abrupt("return", result);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _subscribe.apply(this, arguments);
    }

    return subscribe;
  })(options);
};

function readMessages(_x3, _x4) {
  return _readMessages.apply(this, arguments);
}

function _readMessages() {
  _readMessages = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(response, _ref) {
    var onMessage, onEnd, onError, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, msg;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            onMessage = _ref.onMessage, onEnd = _ref.onEnd, onError = _ref.onError;
            onError = onError || log;
            _context2.prev = 2;
            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _context2.prev = 5;
            _iterator = _asyncIterator(response.ndjson());

          case 7:
            _context2.next = 9;
            return _iterator.next();

          case 9:
            _step = _context2.sent;
            _iteratorNormalCompletion = _step.done;
            _context2.next = 13;
            return _step.value;

          case 13:
            _value = _context2.sent;

            if (_iteratorNormalCompletion) {
              _context2.next = 29;
              break;
            }

            msg = _value;
            _context2.prev = 16;

            if (msg.from) {
              _context2.next = 19;
              break;
            }

            return _context2.abrupt("continue", 26);

          case 19:
            onMessage({
              from: msg.from,
              data: httpRpcWireFormat.rpcToBytes(msg.data),
              seqno: httpRpcWireFormat.rpcToBytes(msg.seqno),
              topicIDs: httpRpcWireFormat.rpcArrayToTextArray(msg.topicIDs)
            });
            _context2.next = 26;
            break;

          case 22:
            _context2.prev = 22;
            _context2.t0 = _context2["catch"](16);
            _context2.t0.message = "Failed to parse pubsub message: ".concat(_context2.t0.message);
            onError(_context2.t0, false, msg);

          case 26:
            _iteratorNormalCompletion = true;
            _context2.next = 7;
            break;

          case 29:
            _context2.next = 35;
            break;

          case 31:
            _context2.prev = 31;
            _context2.t1 = _context2["catch"](5);
            _didIteratorError = true;
            _iteratorError = _context2.t1;

          case 35:
            _context2.prev = 35;
            _context2.prev = 36;

            if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
              _context2.next = 40;
              break;
            }

            _context2.next = 40;
            return _iterator.return();

          case 40:
            _context2.prev = 40;

            if (!_didIteratorError) {
              _context2.next = 43;
              break;
            }

            throw _iteratorError;

          case 43:
            return _context2.finish(40);

          case 44:
            return _context2.finish(35);

          case 45:
            _context2.next = 50;
            break;

          case 47:
            _context2.prev = 47;
            _context2.t2 = _context2["catch"](2);

            if (!isAbortError(_context2.t2)) {
              onError(_context2.t2, true);
            }

          case 50:
            _context2.prev = 50;
            onEnd();
            return _context2.finish(50);

          case 53:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[2, 47, 50, 53], [5, 31, 35, 45], [16, 22], [36,, 40, 44]]);
  }));
  return _readMessages.apply(this, arguments);
}

var isAbortError = function isAbortError(error) {
  switch (error.type) {
    case 'aborted':
      return true;

    case 'abort':
      return true;

    default:
      return error.name === 'AbortError';
  }
};

exports.createSubscribe = createSubscribe;